import React from 'react';
import HeroSection from './hero-section';
import OurExpertise from './our-expertise';

export default function Feature() {
    return (
        <>
            <HeroSection />
            <OurExpertise />
        </>
    );
}